import {IUser} from './user';
import { IGroup } from './group';
import { IShift } from './shift';

export interface IChat {
	id?: number;
	user_id?: number;
	chatter_type?: ChatterType;
	chatter_id?: number;
	message?: string;
	messaged_at?: Date;
	unread_messages?: number;
	created_at?: Date;
	updated_at?: Date;
	deleted_at?: Date;
	shift?: IShift;

	chatter?: IUser | IGroup;
}

export enum ChatterType {
	User = 'App\\Model\\User',
	Group = 'App\\Model\\Group',
}
